import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import FaqBlock from "../components/FaqBlock";

export default function FAQPage() {
  return (
    <Layout>
      <SEO title="Frequently Asked Questions | Revive Solutions Elica Service" description="Answers to common questions about our Elica service coverage, pricing, spare parts, doorstep service and online booking." canonical="/faq" />
      <section className="bg-[#0b1220] text-white py-14">
        <div className="max-w-5xl mx-auto px-6">
          <div className="chip chip-dark mb-4">FAQ</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium leading-tight mb-3">Frequently Asked Questions</h1>
          <p className="text-white/70 max-w-2xl">All the things customers usually want to know before booking.</p>
        </div>
      </section>
      <FaqBlock />
    </Layout>
  );
}
